module.exports = new __parcel__URL__("jpd-list-blank-darkmode.2847d966.svg").toString();